import { TableWrapperBaseController } from "../../generated/lib/controllers/table-wrapper-base-controller"

/**
 * Child Controller of TableWrapperBaseController
 **/
export default class TableWrapperController extends TableWrapperBaseController {
  static targets = [...TableWrapperBaseController.targets]

  static values = { ...TableWrapperBaseController.values }

  connect() {
    super.connect();
    this.firstRowLabels = this.getFirstRowLabels();
    this.iterateTableColumnsAndCells();
  }

  getFirstRowLabels() {
    const tables = this.element.querySelectorAll('table');
    const firstRowLabels = [];
    tables.forEach(table => {
      const firstRow = table.querySelector('tr');
      if (firstRow) {
        const cells = firstRow.querySelectorAll('th, td');
        cells.forEach(cell => {
          firstRowLabels.push(cell.textContent.trim());
        });
      }
    });
    return firstRowLabels;
  }

  iterateTableColumnsAndCells() {
    const tables = this.element.querySelectorAll('table');
    tables.forEach(table => {
      const rows = table.querySelectorAll('tr');
      rows.forEach(row => {
        const cells = row.querySelectorAll('td');
        cells.forEach((cell, index) => {
          const columnLabel = this.firstRowLabels[index];
          this.applyConditionalFormatting(cell, columnLabel);
        });
      });
    });
  }


  applyConditionalFormatting(cell, columnLabel) {
    const conditionals = this.conditionalsValue || [];
    for (const condition of conditionals) {
      const conditionResult = this.evaluateCondition(condition, condition.type == 'column' ? columnLabel : cell.textContent.trim());
      if (conditionResult) {
        cell.style.backgroundColor = condition.background_color || '';
        cell.style.color = condition.font_color || '';
        if (condition.bold) {
          cell.style.fontWeight = 'bold';
        }
        if (condition.italic) {
          cell.style.fontStyle = 'italic';
        }
      }
    }
  }

  evaluateCondition(condition, textValue) {
    // mode can be "equal", "contains", "startsWith", "endsWith"
    const { mode, text, background_color, font_color } = condition;
    switch (mode) {
      case 'equal':
        return textValue === text;
      case 'contains':
        return textValue.includes(text);
      case 'startsWith': // not yet implemented in ACF/WP
        return textValue.startsWith(text);
      case 'endsWith': // not yet implemented in ACF/WP
        return textValue.endsWith(text);
      default:
        return false;
    }

  }


}